<template>
  <div :class="'form-group ' + { error: validationErrors.length }">
    <label for="title">
      {{
        categoryEntryNameLabel
          ? categoryEntryNameLabel
          : lang.get('entries.form.title.label')
      }}
    </label>
    <help-icon
      v-if="lang.has('entries.form.title.help')"
      :content="lang.get('entries.form.title.help')"
    />
    <input
      id="title"
      v-model="entryTitle"
      type="text"
      class="form-control"
      :disabled="isDisabled"
    />
    <validation-errors :validation-errors="validationErrors" />
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';
import ValidationErrors from '../../lib/components/Fields/ValidationErrors.vue';
import HelpIcon from '../../lib/components/Shared/HelpIcon';

export default {
  inject: ['lang'],
  components: {
    ValidationErrors,
    HelpIcon
  },
  computed: {
    ...mapGetters('entryForm', ['categoryEntryNameLabel']),
    ...mapState('entryForm', ['title', 'locks']),
    ...mapState('entryFormApi', ['errorBag']),
    entryTitle: {
      set(title) {
        this.updateTitle(title);
      },
      get() {
        return this.title;
      }
    },
    validationErrors() {
      return this.errorBag && this.errorBag.title
        ? this.errorBag.title.message
        : [];
    },
    isDisabled() {
      return this.locks.lockedOnSubmission || this.locks.readOnly || this.locks.seasonNotActive;
    }
  },
  methods: {
    ...mapMutations('entryForm', ['updateTitle'])
  }
};
</script>
